import axios from "axios";
import {getApiDomain} from "./config";

const apiDomain = getApiDomain();
const defaultConfig = {
    headers: {"Content-type": "application/json"},
};

const axiosManager = {
    axiosInstance: axios.create({
        baseURL: apiDomain,
        headers: {
            "Access-Control-Allow-Origin": "*",
            ...defaultConfig.headers,
        },
    }),

    sessionKey: null,
    requestInterceptorId: null,

    setupInterceptor() {
        if (this.requestInterceptorId !== null) {
            this.axiosInstance.interceptors.request.eject(this.requestInterceptorId);
            this.requestInterceptorId = null;
        }

        if (this.sessionKey) {
            this.requestInterceptorId = this.axiosInstance.interceptors.request.use(
                (config) => {
                    config.headers.set("X-Session-Key", this.sessionKey);
                    return config;
                },
                (error) => Promise.reject(error),
            );
        }
    },

    setSessionKey(sessionKey) {
        this.sessionKey = sessionKey;
        this.setupInterceptor();
    },

    removeSessionKey() {
        this.sessionKey = null;
        this.setupInterceptor();
    },

    request(url, method, data, config) {
        return this.axiosInstance.request({
            ...defaultConfig,
            ...config,
            headers: {...defaultConfig.headers, ...config?.headers},
            url,
            method,
            data,
        });
    },

    get$(url, config) {
        return this.request(url, "GET", null, config);
    },

    post$(url, data, config) {
        return this.request(url, "POST", data, config);
    },

    put$(url, data, config) {
        return this.request(url, "PUT", data, config);
    },

    patch$(url, data, config) {
        return this.request(url, "PATCH", data, config);
    },

    delete$(url, data, config) {
        return this.request(url, "DELETE", data, config);
    },

    head$(url, config) {
        return this.request(url, "HEAD", null, config);
    },
};

export default axiosManager;
